import { generateFontStyleFromSystem } from "../font-styles";
import { css } from "styled-components";
import { Lazy } from "lib/lazy";

const iconsolataFont = "Inconsolata, BlinkMacSystemFont, Roboto, sans-serif";
const cairoFont = "Cairo, BlinkMacSystemFont, Roboto, sans-serif";

export const futureFontOverlay = new Lazy(() =>
    generateFontStyleFromSystem({
        AccentHeader: {
            weights: [700, 700, 700, 700, 700, 600, 600],
            fontFamily: iconsolataFont,
        },
        AccentSubheader: {
            weights: 600,
            fontFamily: iconsolataFont,
        },
        AccentCallout: {
            weights: 600,
            fontFamily: iconsolataFont,
        },
        AccentBody: {
            weights: 500,
            fontFamily: iconsolataFont,
        },
        Header: {
            weights: [700, 700, 600, 500, 500, 500, 500],
        },
        Subheader: 600,
        Callout: 400,
        Body: 400,
        Caption: 400,
        Tag: {
            weights: 600,
            sizes: [22, 18, 15, 13, 11, 9, 8],
            css: css`
                text-transform: uppercase;
            `,
        },
        defaultFontFamily: cairoFont,
        defaultFontSizes: [34, 24, 20, 16, 14, 12, 10],
        defaultLineHeights: [37, 29, 24, 19, 19, 17, 14],
        load: ["Inconsolata:400,500,600,700", "Cairo:400,600,700"],
    })
);
